export default __webpack_public_path__ + "static/media/hospital.7f5a8a11.png";